export default "<div ng-class=\"[$ctrl.style.container, { [$ctrl.style.disabled]: $ctrl.ngDisabled }]\">\n  <ng-transclude></ng-transclude>\n</div>\n"